import { Box, Modal } from "@mui/material";
import { cloneDeep, get, set } from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CtaComponent from "../../../components/reusable-ui/cta";
import { isMobileDevice } from "../../../helpers/device-info-helper";
import { CTA_SIZE, CTA_TYPE } from "../../../data/constants";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import DeleteIcon from "@mui/icons-material/Delete";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import {
  deleteTrxnAttachment,
  downloadTrxnAttachment,
} from "../../../redux/slices";
import { toastSuccess } from "../../../utils/react-toaster";
import { ATTACHMENT_DELETED } from "./cash-managment-constants";

interface Props {
  onModalClose: (...args: any[]) => void;
  transactionInfo: any;
  openEditTransaction: (...args: any[]) => void;
  refreshTableData: (...args: any[]) => void;
  showEditBtnCheck: any;
  branchName: string;
}

const TransactionInfoModal = (props: Props) => {
  const {
    onModalClose,
    transactionInfo,
    openEditTransaction,
    refreshTableData,
    showEditBtnCheck,
    branchName,
  } = props;

  const dispatch = useDispatch();
  const cashierTransaction = transactionInfo?.localTransactions?.[transactionInfo?.localTransactions?.length - 1];

  const downloadAttachment = () => {
    const callback = (isSuccess: boolean, response: any) => {
      if (isSuccess && response?.fileURL) {
        window.location.href = `${response?.fileURL}`;
      }
    };
    let dataToPost = {
      id: transactionInfo._id,
      attachmentId: transactionInfo.attachments[0].id,
      fileName: transactionInfo.attachments[0].fileName,
    };
    dispatch(downloadTrxnAttachment({ dataToPost, callback }));
  };

  const deleteAttachment = () => {
    const callback = (isSuccess: boolean) => {
      if (isSuccess) {
        toastSuccess(ATTACHMENT_DELETED);
        refreshTableData();
        onModalClose();
      }
    };
    let dataToPost = {
      id: transactionInfo._id,
      attachmentId: transactionInfo.attachments[0].id,
      fileName: transactionInfo.attachments[0].fileName,
    };
    dispatch(deleteTrxnAttachment({ dataToPost, callback }));
  };

  function renderModalHeader() {
    return (
      <div
        className={`flex items-center justify-between py-[12px] px-[24px] 
          w-full sm:px-[16px]
        `}
      >
        <div className="flex items-center sm:gap-15">
          {isMobileDevice() && (
            <KeyboardBackspaceIcon
              sx={{ fontSize: "28px" }}
              onClick={onModalClose}
            />
          )}
          <p className="text-18 font-semibold">Transaction Details</p>
        </div>
        <div
          className="rista-sprite ic-cross-black sm:hidden"
          onClick={onModalClose}
        ></div>
        {isMobileDevice() && (
          <CtaComponent
            ctaText={"Discard"}
            ctaType={CTA_TYPE.secondary_cta}
            ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
            onCtaClick={onModalClose}
            customClass={"mr-10 sm:mr-[8px]"}
          ></CtaComponent>
        )}
      </div>
    );
  }

  function renderTrxnInfo() {
    return (
      <div className="left-side">
        <div className="flex items-center sm:block">
          <div className="text-14 text-black opacity-50 pb-10 sm:pb-8 w-1/5 sm:w-full">
            User {isMobileDevice() ? "" : ":"}
          </div>
          <div className="text-14 text-black pb-10 sm:pb-20">
            {transactionInfo?.updatedBy?.userName?.firstName || ""}
          </div>
        </div>
        <div className="flex items-center sm:block">
          <div className="text-14 text-black opacity-50 pb-10 w-1/5 sm:w-full">
            Transaction date {isMobileDevice() ? "" : ":"}
          </div>
          <div className="text-14 text-black pb-10 sm:pb-20">
            {(transactionInfo.transactionDate || cashierTransaction?.transactionDate)}
          </div>
        </div>
        { transactionInfo.receiveFrom && 
          <div className="flex items-center sm:block">
            <div className="text-14 text-black opacity-50 pb-10 w-1/5 sm:w-full">
              Received from {isMobileDevice() ? "" : ":"}
            </div>
            <div className="text-14 text-black pb-10 sm:pb-20">
              {transactionInfo.receiveFrom || cashierTransaction?.transactionDate}
            </div>
          </div>
        }
        { transactionInfo.transferredTo && 
          <div className="flex items-center sm:block">
            <div className="text-14 text-black opacity-50 pb-10 w-1/5 sm:w-full">
              Transferred To {isMobileDevice() ? "" : ":"}
            </div>
            <div className="text-14 text-black pb-10 sm:pb-20">
              {transactionInfo.transferredTo || cashierTransaction?.transactionDate}
            </div>
          </div>
        }
        <div className="flex items-center sm:block">
          <div className="text-14 text-black opacity-50 pb-10 w-1/5 sm:w-full">
            Date added {isMobileDevice() ? "" : ":"}
          </div>
          <div className="text-14 text-black pb-10 sm:pb-20">
            {transactionInfo.updatedBy?.date &&
              moment(transactionInfo.updatedBy.date).format(
                "DD-MMM-YYYY | h:mm A"
              )}
          </div>
        </div>
        <div className="flex items-center sm:block">
          <div className="text-14 text-black opacity-50 pb-10 w-1/5 sm:w-full">
            Reason {isMobileDevice() ? "" : ":"}
          </div>
          <div className="text-14 text-black pb-10 sm:pb-20">
            {transactionInfo.reason || cashierTransaction?.reason}
          </div>
        </div>
        { transactionInfo.remarks && 
          <div className="flex sm:block">
            <div className="text-14 text-black opacity-50 pb-10 w-1/5 sm:w-full">
              Remark {isMobileDevice() ? "" : ":"}
            </div>
            <div className="text-14 text-black pb-10 w-4/5 sm:w-full">
              {transactionInfo.remarks || "N/A"}
            </div>
          </div>
        }
      </div>
    );
  }

  function renderFileView(){
    return(
      <div className="attachment-cnt px-24 pb-20">
        <div className="attachment-info-section flex justify-between items-center border border-[#CFD3D8] rounded-[8px] p-12">
          <div className="flex items-center gap-10">
            <AttachFileIcon
              sx={{ color: "#6C6C6C", transform: "rotate(45deg)" }}
            />
            <span className="text-15 text-[#020202]">
              {transactionInfo.attachments[0].fileName}
            </span>
          </div>
          <div className="flex items-center gap-10">
            <VerticalAlignBottomIcon
              sx={{ color: "#0074FB", cursor: "pointer" }}
              onClick={downloadAttachment}
            />
            <DeleteIcon
              sx={{ color: "#F56969", cursor: "pointer" }}
              onClick={deleteAttachment}
            />
          </div>
        </div>
      </div>
    )
  }

  function renderBtn(){
    return(
      <div className="btn-cnt flex items-center">
        <CtaComponent
          ctaText={"Discard"}
          ctaType={CTA_TYPE.secondary_cta}
          ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
          onCtaClick={onModalClose}
          customClass={"mr-10 sm:mr-[8px]"}
        ></CtaComponent>
        {showEditBtnCheck(transactionInfo.transactionType) && (
          <CtaComponent
            ctaText={"Edit"}
            ctaType={CTA_TYPE.active_cta}
            ctaSize={isMobileDevice() ? CTA_SIZE.small : CTA_SIZE.medium}
            onCtaClick={openEditTransaction}
            customClass={"ml-10 sm:ml-[8px] py-6"}
            isDisabled={false}
          ></CtaComponent>
        )}
      </div>
    )
  }

  return (
    <Modal open={true} onClose={onModalClose}>
      <div
        className={`transaction-info-modal absolute w-[765px] sm:w-full sm:h-full rounded-[8px] sm:rounded-[0px]
          overflow-hidden left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2  bg-white`}
      >
        {renderModalHeader()}
        <div className="amount-branch-info-cnt bg-[#397ef50d] grid grid-cols-[0.5fr_0.7fr_1.5fr_1fr] items-center border border-[#CFD3D8] py-10 pl-36 pr-25 sm:hidden">
          <div className="text-16 font-medium text-[#333333] border-r border-[#ECECEC] py-10">
            ₹{(transactionInfo.amount || cashierTransaction?.amount) || 0}
          </div>
          <div className="text-center border-r border-[#ECECEC]">
            <div className="text-16 font-normal text-[#333333]">
              {(transactionInfo.mode || cashierTransaction?.mode)}
            </div>
            <div className="text-14 font-normal text-[#333333] opacity-30">
              {(transactionInfo.transactionType || cashierTransaction?.transactionType)}
            </div>
          </div>
          <div className="text-16 font-medium text-[#333333] text-center">
            Branch: {branchName}
          </div>
          {renderBtn()}
        </div>
        <div className="hidden sm:flex justify-between items-baseline bg-[#397ef50d] p-20">
          <div className="amt-branch-info-mb">
            <div className="text-16 font-semibold text-[#333333]">
              {transactionInfo.mode || cashierTransaction?.mode} | ₹{(transactionInfo.amount || cashierTransaction?.amount )|| 0}
            </div>
            <div className="text-12 text-black pt-8">
              {(transactionInfo.transactionType || cashierTransaction?.transactionType)}
            </div>
            <div className="text-14 font-medium text-[#333333] pt-15">
              Branch: Kormangla
            </div>
          </div>
          <div className="edit-btn flex items-center">
            <span className="text-14 font-medium text-[#397EF5] inline-block pr-5">
              Edit
            </span>
            <EditIcon
              sx={{ color: "#397EF5", fontSize: "15px" }}
              onClick={openEditTransaction}
            />
          </div>
        </div>
        <div className="other-info-cnt py-30 px-36">{renderTrxnInfo()}</div>
        {transactionInfo.attachments?.length > 0 && (
          <>
            {renderFileView()}
          </>
        )}
      </div>
    </Modal>
  );
};

export default TransactionInfoModal;
